import React, { useState } from "react";
import { ArrowRight } from "lucide-react";
import cardInvitePhoto from "../../../assets/portal/card-invite.jpg";
import cardAppPhoto from "../../../assets/portal/card-app.jpg";
import { BG_SOFT, BRAND, BRAND_DARK, TEXT_INK, TEXT_DARK, BORDER, CONTAINER } from "../tokens";

interface Card {
  title: string;
  body: string;
  img: string;
}

interface KnowledgeCardProps { card: Card; }

function KnowledgeCard({ card }: KnowledgeCardProps) {
  const [hovered, setHovered] = useState(false);
  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        background: "#FFFFFF",
        border: "0.5px solid " + BORDER,
        borderRadius: 16,
        overflow: "hidden",
        cursor: "pointer",
        transform: hovered ? "translateY(-10px)" : "translateY(0)",
        boxShadow: hovered ? "0 26px 60px rgba(8,32,31,0.22)" : "0 1px 2px rgba(0,0,0,0.04)",
        transition: "transform 0.25s ease, box-shadow 0.25s ease",
      }}
    >
      <div style={{ height: 230, overflow: "hidden" }}>
        <img
          src={card.img}
          alt={card.title}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            objectPosition: "center 38%",
            display: "block",
            transform: hovered ? "scale(1.06)" : "scale(1)",
            transition: "transform 0.25s ease",
          }}
        />
      </div>
      <div style={{ padding: 28 }}>
        <h3 style={{ fontSize: 20, fontWeight: 700, color: TEXT_INK, letterSpacing: "-0.01em", margin: "0 0 10px" }}>{card.title}</h3>
        <p style={{ fontSize: 14.5, color: TEXT_DARK, lineHeight: 1.6, margin: "0 0 18px" }}>{card.body}</p>
        <span style={{ display: "inline-flex", alignItems: "center", gap: 6, fontSize: 13, fontWeight: 700, color: hovered ? BRAND_DARK : BRAND, padding: "7px 14px", border: "1px solid " + (hovered ? BRAND : BORDER), borderRadius: 8, transition: "color 0.2s ease, border-color 0.2s ease" }}>
          Learn more <ArrowRight size={14} />
        </span>
      </div>
    </div>
  );
}

export default function KnowledgeCards() {
  const cards: Card[] = [
    { title: "Invite your team to add their own info", body: "Send one invite. Your team adds their own banking, contact, and tax forms straight from their phone, so you do not type any of it.", img: cardInvitePhoto },
    { title: "Track time and pay in one app", body: "One app for clock in and out, the latest pay, the next shift, and year end tax documents. No second app, no extra logins.", img: cardAppPhoto },
  ];
  return (
    <section style={{ background: BG_SOFT, padding: "100px 0" }}>
      <div style={CONTAINER}>
        <div style={{ textAlign: "center", marginBottom: 44 }}>
          <h2 style={{ fontSize: "clamp(30px, 3.5vw, 40px)", fontWeight: 800, color: TEXT_INK, letterSpacing: "-0.02em", margin: 0 }}>Build your knowledge</h2>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 24 }}>
          {cards.map((c, i) => <KnowledgeCard key={i} card={c} />)}
        </div>
      </div>
    </section>
  );
}